var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTruckload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.482,
    height: 19,
    viewBox: "0 0 19.482 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_truckload",
    d: "M14.309,17.6a1.581,1.581,0,0,1-2.546-.651H5.183a1.582,1.582,0,0,1-2.983,0H0v-3.8l1.591-3.58H6.328v4.219h6.4L7.559,7.752h2.584V0h5.168V7.752h2.584l-5.168,6.029H18v1.055H15.363a1.582,1.582,0,1,1-1.055,2.76Zm.527-1.178a.527.527,0,1,0,.527-.527A.528.528,0,0,0,14.836,16.418Zm-2.109,0a.527.527,0,1,0,.527-.527A.528.528,0,0,0,12.727,16.418Zm-9.562,0a.527.527,0,1,0,.527-.527A.528.528,0,0,0,3.164,16.418ZM1.339,12.727H3.516V10.617H2.276Z",
    transform: "translate(0.5 0.5)",
    fill: "#0045d9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruckload);
export default __webpack_public_path__ + "static/media/icon_truckload.adca65a364c9ccafe846d0bb33f14ed9.svg";
export { ForwardRef as ReactComponent };